import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import Textlink from '@xingternal/malt-textlink';
import { H, P } from '@xingternal/malt-typography';
import { AdProvider, SkyscraperAd } from '@xingternal/adprovider';

import parseQueryString from './../../utils/parseQueryString';
import PageviewTracker from '../../Components/PageviewTracker/PageviewTracker';
import Spacer from './../../Components/Spacer/Spacer';

import messages from './messages';

const buildLink = (to, message) => (
  <Textlink testId={'login-again-link'} to={to}>
    <FormattedMessage {...message} />
  </Textlink>
);

/**
 * We expect the query string to have a param 'kvp'
 * (key-value pairs) that has additional tracking values.
 * The key-value pairs are separated by semicolons.
 */
export const flattenTrackingParams = ({ kvp, ...params } = {}) => {
  if (!kvp) return { ...params };
  const objectifiedKvp = kvp
    .split(';')
    .map(string => {
      const [key, value] = string.split('=');
      return { [key]: value };
    })
    .reduce((prev, curr) => ({ ...prev, ...curr }), {});
  return { ...params, ...objectifiedKvp };
};

const Logout = ({ location }) => {
  const adParams = flattenTrackingParams(parseQueryString(location.search));

  return (
    <Fragment>
      <PageviewTracker pageName={'wbm/Welcome/logout'} />
      <Spacer size={8} />
      <H>
        <FormattedMessage {...messages.headline} />
      </H>
      <P>
        <FormattedMessage
          {...messages.comeback}
          values={{
            loginLink: buildLink('/', messages.loginLinkText),
          }}
        />
      </P>
      <div>
        <AdProvider logoutAd logoutTracking={adParams || {}}>
          <SkyscraperAd id={'89'} reloading nofence />
        </AdProvider>
      </div>
    </Fragment>
  );
};

export default Logout;
